import o from "./ghl-ui.es822.js";
import t from "./ghl-ui.es823.js";
import r from "./ghl-ui.es824.js";
import a from "./ghl-ui.es825.js";
import m from "./ghl-ui.es826.js";
var e = {
  code: "fr",
  formatDistance: o,
  formatLong: t,
  formatRelative: r,
  localize: a,
  match: m,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const s = e;
export {
  s as default
};
